<template>
  <div class="list_index">
    <el-row :gutter="10">
      <el-col :span="1.5">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          class="yl-button"
          @click="handleAdd"
        >新增</el-button>
      </el-col>
    </el-row>
    <el-table stripe border :data="tableData" :row-style="{height: '0'}" :cell-style="{padding: '1px'}">
      <el-table-column label="设备名称" prop="equipment_name" align="center"></el-table-column>
      <el-table-column label="设备型号" prop="equipment_model" align="center">
        <template slot="header">
          <span>设备型号</span>
          <el-tooltip 
            class="item" 
            effect="dark" 
            placement="bottom"
            popper-class="prompt_tooltip">
            <div slot="content">
            设备型号，也即超级表名称，填写的内容需要和mqtt网关上报数据的Topic中定义的超级表字段一致。
            <br/>mqtt网关上报数据的Topic格式：updates/超级表名称/mqtt网关型号/SN</div>
            <img class="promptIcon" src="../../assets/images/prompt.png" alt="">
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="模板" prop="templateName" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="toTemplateDetail(scope.row)">管理模板</el-button>
        </template>
      </el-table-column>
      <el-table-column label="变量表" prop="templateName" align="center">
        <template slot-scope="scope">
          <div style="display:flex;justify-content: center;">
            <el-upload
              class="item"
              ref="upload"
              accept=".xls,.xlsx"
              :multiple="false"
              :action="actionUrl"
              :data="data"
              :headers="uploadHeaders"
              :on-success="uploadSuccess"
              :show-file-list="false"
            >
              <el-button type="text" @click="upload(scope.row)">导入</el-button>
            </el-upload>
            <el-button type="text" class="item" @click="exportData(scope.row)">导出</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button @click="edit(scope.row)" type="text" icon="el-icon-bj" size="small"></el-button>
          </el-tooltip>
          <!-- <el-tooltip class="item" effect="dark" content="上传变量" placement="top">
            <el-upload
              class="upload"
              ref="upload"
              accept=".xls,.xlsx"
              :multiple="false"
              :action="actionUrl"
              :data="data"
              :headers="uploadHeaders"
              :on-success="uploadSuccess"
              :show-file-list="false"
            >
              <el-button @click="upload(scope.row)" type="success" circle icon="el-icon-upload" size="small"></el-button>
            </el-upload>
          </el-tooltip> -->
          <el-tooltip class="item" effect="dark" content="复制模板" placement="top">
            <el-button @click="copyTemplate(scope.row)" type="text" icon="el-icon-fz" size="small"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button type="text" icon="el-icon-sc" size="small" @click="deleteTemplate(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        layout="total, prev, pager, next, jumper"
        :current-page="page"
        :page-size="size"
        :total="count"
        @current-change="changePage"
      ></el-pagination>
      <el-dialog :title="type == 1?'新增设备模板' : type == 2?'修改设备模板':'复制设备模板'" :visible.sync="DeviceTemplate" width="30%">
        <el-form :model="form" label-position="right" label-width=".8rem" ref="addDeviceTemplate" :rules="rules">
          <el-form-item label="设备名称" prop="equipment_name">
            <el-input type="text" class="yl-input_noIcon" size="small" placeholder="请输入设备名称" v-model="form.equipment_name" ></el-input>
          </el-form-item>
          <el-form-item label="设备型号" prop="equipment_model" v-if="type != 2">
            <el-input type="text" class="yl-input_noIcon" size="small" placeholder="请输入设备型号" v-model="form.equipment_model" ></el-input>
          </el-form-item>
          <!-- <el-form-item label="选择模板">
            <el-select v-model="form.templateName" size="small">
              <el-option v-for="(item,index) in list" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="mini" class="yl-button" @click="submitForm()">确 定</el-button>
          <el-button @click="cancel" size="mini" class="yl-button2">取 消</el-button>
        </span>
      </el-dialog>
    </div>
      <!-- <photo /> -->
      <!-- <scatterEchart /> -->
  </div>
</template>

<script>
import DeviceTemplateService from '@/api/deviceTemplate'
import scatterEchart from '@/components/template/scatterEchart.vue'
export default {
  components:{
      scatterEchart
  },
  data(){
    return{
      oldEquipmentName:'',
      oldParentPageModel:'',
      tableData:[],
      DeviceTemplate:false,
      type:1,
      page: 1,
      count: 0,
      size:10,
      form:{
        equipment_name:'',
        equipment_model:'',
        templateName:''
      },
      rules:{
        equipment_name:[{ required: true,message: '请输入设备名称', trigger: 'blur' }],
        equipment_model:[{ required: true,message: '请输入设备型号', trigger: 'blur' }],
      },
      // list:[],
      data:{}
    }
  },
   computed:{
    actionUrl() {
      return process.env.NODE_ENV === "development"
        ? "api/projectsite/importVariableName"
        : process.env.BASE_URL + "/projectsite/importVariableName";
    },
    uploadHeaders() {
      return {
        Authorization: this.$store.state.token,
      };
    },
  },
  methods:{
    upload(val){
      this.data = {
        // user_id:this.$store.state.user_id,
        equipmentModel:val.equipment_model
      }
    },
    //上传变量
    uploadSuccess(res, file, fileList) {
      console.log(file)
      if (res.code === 200) {
        this.$message.success("操作成功");
      } else {
        this.$message.error(res.msg);
      }
    },
    exportData(val){
      window.location.href = process.env.NODE_ENV === "development"?`api/projectsite/exportVariableName?equipmentModel=${val.equipment_model}`:
      `${process.env.BASE_URL}/projectsite/exportVariableName?equipmentModel=${val.equipment_model}`
    },
    //复制模板
    copyTemplate(val){
      this.type = 3;
      this.form = {};
      this.oldParentPageModel = val.equipment_model;
      this.oldEquipmentName = val.equipment_name;
      this.DeviceTemplate = true;
    },
    //跳转模板详情页面
    toTemplateDetail(val){
      this.$router.push({
        path:'/templateDetail',
        query:{
          parentPageModel:val.equipment_model,
          equipmentName:val.equipment_name
        }
      })
    },
    //获取模板列表
    // getTemplateList(){
    //   DeviceTemplateService.getTemplateList({
    //     user_id:this.$store.state.user_id
    //   }).then(res=>{
    //     this.list = res.data;
    //   }).catch(err=>{
    //     this.$message.error(err.message)
    //   })
    // },
    //获取列表数据
    getDataList(){
      DeviceTemplateService.getDeviceTemplate({
        user_id:this.$store.state.user_id,
        isPaging:1,
        page:this.page,
        size:this.size
      }).then(res=>{
        console.log(res)
        this.tableData = res.data.projectSiteList;
        this.count = res.data.count;
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    changePage(page) {
      this.page = page;
      this.getDataList();
    },
    handleAdd(){
      this.type = 1;
      this.form = {};
      this.DeviceTemplate = true;
    },
    //取消添加设备模板
    cancel(){
      this.DeviceTemplate = false;
      this.resetForm('addDeviceTemplate');
    },
    //提交设备模板表单
    submitForm(){
      this.$refs.addDeviceTemplate.validate((valid)=>{
        if(valid){
          if(this.type == 1){
            DeviceTemplateService.addDeviceTemplate({
              ...this.form,
              user_id:this.$store.state.user_id,
              username:this.$store.state.username
              }).then(res=>{
              this.$message.success('新增成功')
              this.resetForm('addDeviceTemplate');
              this.DeviceTemplate = false;
              this.getDataList();
            }).catch(err=>{
              this.$message.error(err.message)
            })
          }else if(this.type == 2){
            DeviceTemplateService.editDeviceTemplate({
              ...this.form,
              user_id:this.$store.state.user_id,
              oldEquipmentName:this.oldEquipmentName,
              username:this.$store.state.username
              }).then(res=>{
              this.$message.success('修改成功')
              this.resetForm('addDeviceTemplate');
              this.DeviceTemplate = false;
              this.getDataList();
            }).catch(err=>{
              this.$message.error(err.message)
            })
          }else if(this.type == 3){
            DeviceTemplateService.copyTemplate({
              user_id:this.$store.state.user_id,
              oldParentPageModel:this.oldParentPageModel,
              oldEquipmentName:this.oldEquipmentName,
              newParentPageModel:this.form.equipment_model,
              equipment_name:this.form.equipment_name,
              username:this.$store.state.username
            }).then(res=>{
              this.$message.success('复制成功');
              this.DeviceTemplate = false;
              this.getDataList();
            }).catch(err=>{
              this.$message.error(err.message)
            })
          }
        }else{
          this.$message.error("请检查必填项");
          return false;
        }
      })
    },
    //点击修改设备模板
    edit(e){
      this.type = 2;
      this.form.equipment_name = e.equipment_name;
      this.form.equipment_model = e.equipment_model;
      this.oldEquipmentName = e.equipment_name;
      this.DeviceTemplate = true;
    },
    //删除模板
    deleteTemplate(val){
      let _this = this;
      this.$confirm('是否确认删除设备模板名称为"' + val.equipment_name + '"的数据项?', "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function() {
          DeviceTemplateService.deleteDeviceTemplate({
            user_id:_this.$store.state.user_id,
            equipment_name:val.equipment_name,
            equipment_model:val.equipment_model,
            username:_this.$store.state.username
          }).then(res=>{
            _this.$message.success('删除成功');
            _this.getDataList()
          }).catch(err=>{
            _this.$message.error(err.message)
          })
        })
    },
  },
  mounted(){
    this.getDataList()
    // this.getTemplateList()
  }
}
</script>

<style lang="scss" scoped>
.item{
  float: center;
  margin:0 10px ;
  margin-bottom: 3px;
}
// .upload{
//   float: left;
// }
.promptIcon{
  width: 20px;
  cursor: pointer;
  vertical-align: middle;
}

</style>
<style>
.prompt_tooltip{
  font-size: 18px;
}
</style>